export const defaultUserImg = 'https://flowing-web-resources.s3.ap-northeast-2.amazonaws.com/default-profile.png';
